import React from 'react';
import {ConfigApi, OrderType} from "../../../../../../../../services/Api/types";
import {connect} from "react-redux";
import {RootState} from "../../../../../../../../../reducers";
import {getUser} from "../../../../../../../../services/User/reducer";
import {getStoreConfigLoyalty} from "../../../../../../../../services/Store/reducer";
import {getSession} from "../../../../../../../../services/Session/reducer";
import NavbarMulti from "../../../../../../../../components/Navbar/NavbarMulti";
import FetchPlaces from "../../../../../../../../components/Fetch/FetchPlaces";
import Footer from "../../../../../../../../components/layout/Footer/Footer";
import {getLanguagesBasedOnStoreType} from "../../../../../../../../services/languageUtils";
import MultistoreWithHomePageDeliverySection from "./Delivery/MultistoreWithHomePageDeliverySection";
import {useTranslation} from "react-i18next";
import MultistoreWithMapHomePageOtherTypesSection from "./MultistoreWithMapHomePageOtherTypesSection";
import {usePlaceContext} from "../../../../../../../../services/Place/PlaceContext";
import {getMultistoreOrderTypes} from "../../../../../../utils/multistoreUtils";

interface OwnProps {
    config: ConfigApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreWithMapHomePage = ({config}: Props) => {
    const {t} = useTranslation();
    const {places} = usePlaceContext();
    const orderTypes = getMultistoreOrderTypes(places ?? []);

    return (
        <div className="multistore-home-page multistore-with-map-home-page">
            <NavbarMulti config={config}/>
            <FetchPlaces>
                <div className="inner-container">
                    <div className="container-fluid">
                        <div className="online-order-section">
                            <div className="online-order-section-inner-container">
                                <h1>{t("modules.multistore.field.order_online.title")}</h1>
                                <div className="online-order-section-cards">
                                    {orderTypes.includes(OrderType.DELIVERY) && (
                                        <MultistoreWithHomePageDeliverySection/>
                                    )}
                                    {
                                        orderTypes.length > 0 && orderTypes.some(orderType => orderType !== OrderType.DELIVERY) && (
                                            <MultistoreWithMapHomePageOtherTypesSection orderTypes={orderTypes}/>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FetchPlaces>
            <Footer config={config} languages={getLanguagesBasedOnStoreType(config)} withoutMap/>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);

export default connector(MultistoreWithMapHomePage);